module.exports = __webpack_public_path__ + "static/img/image_news_over_12.704dcf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_12.png
// module id = BF+n
// module chunks = 10